(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@fiverr/globals"), require("react"), require("prop-types"));
	else if(typeof define === 'function' && define.amd)
		define(["@fiverr/globals", "react", "prop-types"], factory);
	else if(typeof exports === 'object')
		exports["GigCards"] = factory(require("@fiverr/globals"), require("react"), require("prop-types"));
	else
		root["GigCards"] = factory(root["@fiverr/globals"], root["React"], root["PropTypes"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_E4I8__, __WEBPACK_EXTERNAL_MODULE_Jmof__, __WEBPACK_EXTERNAL_MODULE_T9WB__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition